import React from 'react';
import { Layout } from 'antd';
import useUrlState from '../../hooks/useUrlState';
import Header from '../shared/Header';
import DomainSetupCheck from '../websiteIndexEntry/DomainSetupCheck';
import ClusterUrls from '../serviceableUrls/ClusterUrls';
import { useFetchUrlClustersQuery } from '../urlClusters/service';

const { Content } = Layout;

export default function UrlClusterPage() {
    const [urlState] = useUrlState();
    const { w_guid: websiteGuid, cluster_guid: clusterGuid } = urlState;

    const { data: clusters, isLoading } = useFetchUrlClustersQuery({ w_guid: websiteGuid });
    const cluster = clusters?.find((c) => c.guid === clusterGuid);

    return (
        <Content className="general-layout-content">
            {!isLoading && cluster && (<Header
                title={`Page group: ${cluster?.title}`}
                showRedirectArrow
            />)}
            <DomainSetupCheck
                key={websiteGuid}
                websiteGuid={websiteGuid}
            >
                <ClusterUrls
                    websiteGuid={websiteGuid!}
                    clusterGuid={clusterGuid}
                />
            </DomainSetupCheck>
        </Content>
    );
}
